/**
 * Отчёт калькулятора о целостности комплекта: покрывает ли он цепочку «забор →
 * магистраль → доставка» целиком. Ошибки не мешают залить комплект, но не
 * дают его включить; предупреждения — только к сведению.
 *
 * Разбор вынесен из компонента, чтобы правило проверялось тестом, не поднимая
 * экран.
 */
export const RULE_LABELS = {
  SECTION_MISSING: "Нет раздела",
  MIRROR: "Забор и доставка не зеркальны",
  ONE_HUB: "У пункта несколько хабов",
  HUB_SELF: "Нет строки «хаб → сам в себя»",
  HUB_NOT_IN_LINEHAUL: "Хаба нет в магистрали",
  LINEHAUL_PAIR: "Нет направления в магистрали",
  LINEHAUL_SELF: "Нет магистрали «хаб → тот же хаб»",
  INTRACITY_NOT_SELF: "Внутригород между разными городами",
  LADDER_SHORTER: "Короткая лестница без надбавки",
};

/**
 * Нарушения по правилам: у реального комплекта их десятки, и список подряд
 * читать невозможно. Порядок — по числу нарушений, самые массовые сверху.
 */
export const groupIssues = (issues) => {
  const byRule = new Map();
  (issues ?? []).forEach((issue) => {
    const group = byRule.get(issue.rule) ?? { rule: issue.rule, label: RULE_LABELS[issue.rule] ?? issue.rule, items: [] };
    group.items.push(issue);
    byRule.set(issue.rule, group);
  });
  return Array.from(byRule.values()).sort((a, b) => b.items.length - a.items.length);
};

/** Отчёт пришёл и в нём нет ошибок. Отчёта нет вовсе — не «цел», а «не проверен». */
export const isIntact = (report) => Boolean(report) && (report.errors ?? []).length === 0;
